(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute(
        'aria-expanded',
        (this.elements.button.getAttribute('aria-expanded') === 'false').toString()
      );
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerInner = document.querySelector('.header');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
		
		if (this.headerIsAlwaysSticky) this.reveal; 
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		//if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rennkalender"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {

  function initializeCalendar(sectionElement) {
    const sectionId = sectionElement.dataset.sectionId;

    if (sectionElement.dataset.initialized) return;
    sectionElement.dataset.initialized = 'true';
    
    // ===================================================================
    // 1. CONFIG & STATE
    // ===================================================================
    const STOREFRONT_ACCESS_TOKEN = 'e701494532a051b3f9ff4d56c99104e0';
    const GRAPHQL_URL = sectionElement.dataset.graphqlUrl;
    
    const state = {
      allEvents: [],
      filteredEvents: [],
      selectedDate: new Date(),
      viewDate: new Date(),
      selectedSerie: 'all',
    };

    // ===================================================================
    // 2. DOM ELEMENTS
    // ===================================================================
    const desktopView = sectionElement.querySelector(`#rk-desktop-view-${sectionId}`);
    const mobileView = sectionElement.querySelector(`#rk-mobile-view-${sectionId}`);
    const filterDropdown = sectionElement.querySelector(`#rk-filter-serie-${sectionId}`);
    const prevWeekBtn = sectionElement.querySelector(`#rk-prev-week-${sectionId}`);
    const nextWeekBtn = sectionElement.querySelector(`#rk-next-week-${sectionId}`);
    const todayBtn = sectionElement.querySelector(`#rk-today-${sectionId}`);
    const weekDisplay = sectionElement.querySelector(`#rk-week-display-${sectionId}`);
    
    if (!desktopView || !mobileView || !filterDropdown || !GRAPHQL_URL || !prevWeekBtn || !nextWeekBtn || !todayBtn || !weekDisplay) {
      console.error(`[Rennkalender] FEHLER: Wichtige Elemente konnten nicht gefunden werden.`);
      return;
    }

    // ===================================================================
    // 3. DATA FETCH LOGIC
    // ===================================================================
    async function fetchAllEvents() {
      const query = `
        query getRennkalenderEvents($first: Int!) { metaobjects(type: "rennkalender", first: $first) { edges { node { id, titel: field(key: "titel") { value }, datum: field(key: "datum") { value }, type: field(key: "type") { value }, rennserie: field(key: "rennserie") { value }, strecke: field(key: "strecke") { reference { ... on Product { onlineStoreUrl } } } } } } }
      `;
      try {
        const response = await fetch(GRAPHQL_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN },
          body: JSON.stringify({ query, variables: { first: 250 } }),
        });
        if (!response.ok) throw new Error(`GraphQL Error: ${response.statusText}`);
        const json = await response.json();
        if (json.errors) { console.error("[Rennkalender] FEHLER in der GraphQL-Abfrage:", json.errors); return []; }
        return mapGraphQLData(json.data.metaobjects.edges);
      } catch (error) {
        console.error('[Rennkalender] FEHLER beim Abrufen der Rennkalender-Events:', error);
        desktopView.innerHTML = '<p style="color: red;">Events konnten nicht geladen werden.</p>';
        return [];
      }
    }

    function mapGraphQLData(edges) {
      return edges.map(({ node }) => {
        const dateObject = node.datum?.value ? new Date(node.datum.value) : null;
        if (!dateObject || isNaN(dateObject)) return null;
        return { id: node.id, titel: node.titel?.value || 'Unb.', datum: dateObject, type: node.type?.value || 'Allg.', rennserie: node.rennserie?.value || 'Unb.', streckeUrl: node.strecke?.reference?.onlineStoreUrl || '#' };
      }).filter(Boolean).sort((a, b) => a.datum - b.datum);
    }
    
    // ===================================================================
    // 4. HELPER & RENDER FUNCTIONS
    // ===================================================================
    const locale = 'de-DE';
    const dayFormatter = new Intl.DateTimeFormat(locale, { weekday: 'short' });
    const shortDateFormatter = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit' });
    const longDateFormatter = new Intl.DateTimeFormat(locale, { day: '2-digit', month: '2-digit', year: 'numeric' });
    const timeFormatter = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit', hour12: false });
    
    function getStartOfDay(date) {
        const newDate = new Date(date);
        newDate.setHours(0, 0, 0, 0);
        return newDate;
    }

    function getWeekDays(refDate) {
        const startDate = new Date(refDate);
        const dayOfWeek = startDate.getDay();
        const difference = startDate.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
        startDate.setDate(difference);
        return Array.from({length: 7}, (_, i) => {
            const day = new Date(startDate);
            day.setDate(startDate.getDate() + i);
            return day;
        });
    }

    // --- GEÄNDERT: Dynamische Live-Dauer ---
    function createEventTileHTML(event) {
        const typeAttr = event.type.toLowerCase().replace(/\s+/g, '-');
        const now = new Date();
        const startTime = event.datum;

        let durationInMinutes = 60; // Standard: 1 Stunde

        if (event.rennserie === '24H') {
            durationInMinutes = 24 * 60;
        } else {
            const eventTypeLower = event.type.toLowerCase();
            if (eventTypeLower.startsWith('rennen')) {
                durationInMinutes = 90; // 1.5 Stunden
            } else if (eventTypeLower.startsWith('training')) {
                durationInMinutes = 45;
            } else if (eventTypeLower.startsWith('quali')) {
                durationInMinutes = 60;
            }
        }
        
        const endTime = new Date(startTime.getTime() + durationInMinutes * 60 * 1000);
        const isLive = now >= startTime && now <= endTime;

        return `
      <a href="${event.streckeUrl}" class="rk-event-tile" data-serie="${event.rennserie}">
        <div class="row1">
          <span class="title">${event.rennserie}</span>
          <span class="badge" data-type="${typeAttr}">
            ${isLive ? '<span class="live-indicator"></span>' : ''}
            ${event.type}
          </span>
        </div>
        <div class="subtitle">${event.titel}</div>
        <div class="uhrzeit">${timeFormatter.format(event.datum)} Uhr</div>
        <span class="product-link">Zur Strecke &rarr;</span>
      </a>`;
    }

    function renderDesktopView(weekDays, events) {
        const today = getStartOfDay(new Date());
        let html = weekDays.map(day => {
            const dayStart = getStartOfDay(day);
            const isToday = dayStart.getTime() === today.getTime();
            const eventsForDay = events.filter(event => getStartOfDay(event.datum).getTime() === dayStart.getTime());
            return `
            <div class="day-column ${isToday ? 'rk-today' : ''}">
              <div class="day-header">
                ${dayFormatter.format(day)} ${shortDateFormatter.format(day)}
              </div>
              <div class="day-content">
                ${eventsForDay.map(createEventTileHTML).join('')}
              </div>
            </div>`;
        }).join('');
        desktopView.innerHTML = html;
    }

    function renderMobileView(weekDays, events) {
        const selectedDayStart = getStartOfDay(state.selectedDate);
        let navHTML = '<div class="rk-mobile-nav">' + weekDays.map(day => {
            const dayStart = getStartOfDay(day);
            const hasEvents = events.some(e => getStartOfDay(e.datum).getTime() === dayStart.getTime());
            const isSelected = dayStart.getTime() === selectedDayStart.getTime();
            return `
            <button class="rk-mobile-nav-btn ${isSelected ? 'selected' : ''}" data-date="${day.toISOString()}">
              <span class="day-name">${dayFormatter.format(day)}</span>
              <span class="day-date">${day.getDate()}</span>
              ${hasEvents ? '<div class="event-indicator"></div>' : ''}
            </button>`;
        }).join('') + '</div>';

        const eventsForSelectedDay = events.filter(event => getStartOfDay(event.datum).getTime() === selectedDayStart.getTime());
        
        let timelineHTML = '<div class="rk-mobile-timeline">';
        if (eventsForSelectedDay.length === 0) {
            const nextEvent = state.allEvents.find(event => getStartOfDay(event.datum) > selectedDayStart);
            if(nextEvent) {
                timelineHTML += `
                <div class="rk-no-events-container">
                    <p>Keine Events für diesen Tag.</p>
                    <button class="rk-next-event-btn" data-date="${nextEvent.datum.toISOString()}">
                        Nächstes Event am ${longDateFormatter.format(nextEvent.datum)}
                    </button>
                </div>`;
            } else {
                 timelineHTML += '<div class="rk-no-events-container"><p>Keine zukünftigen Events gefunden.</p></div>';
            }
        } else {
            timelineHTML += eventsForSelectedDay.sort((a, b) => a.datum - b.datum).map(createEventTileHTML).join('');
        }
        timelineHTML += '</div>';
        mobileView.innerHTML = navHTML + timelineHTML;
    }
  
    function renderAll() {
        state.filteredEvents = state.allEvents.filter(event => {
            if (state.selectedSerie === 'all') {
                return true;
            }
            return event.rennserie === state.selectedSerie;
        });

        const weekDays = getWeekDays(state.viewDate);
        
        const startOfWeek = weekDays[0];
        const endOfWeek = weekDays[6];
        weekDisplay.textContent = `${longDateFormatter.format(startOfWeek)} - ${longDateFormatter.format(endOfWeek)}`;
        
        if (state.selectedDate < startOfWeek || state.selectedDate > endOfWeek) {
            state.selectedDate = startOfWeek;
        }

        renderDesktopView(weekDays, state.filteredEvents);
        renderMobileView(weekDays, state.filteredEvents);
        addMobileNavListeners();
    }

    // ===================================================================
    // 5. EVENT LISTENERS
    // ===================================================================
    function addEventListeners() {
        filterDropdown.addEventListener('change', (e) => {
            state.selectedSerie = e.target.value;
            renderAll();
        });

        prevWeekBtn.addEventListener('click', () => {
            state.viewDate.setDate(state.viewDate.getDate() - 7);
            renderAll();
        });
        
        nextWeekBtn.addEventListener('click', () => {
            state.viewDate.setDate(state.viewDate.getDate() + 7);
            renderAll();
        });

        todayBtn.addEventListener('click', () => {
            state.viewDate = new Date();
            state.selectedDate = new Date();
            renderAll();
        });
    }
  
    function addMobileNavListeners() {
        const mobileNavButtons = mobileView.querySelectorAll('.rk-mobile-nav-btn');
        mobileNavButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                state.selectedDate = new Date(e.currentTarget.dataset.date);
                renderAll();
            });
        });

        const nextEventBtn = mobileView.querySelector('.rk-next-event-btn');
        if (nextEventBtn) {
            nextEventBtn.addEventListener('click', (e) => {
                const nextEventDate = new Date(e.currentTarget.dataset.date);
                state.viewDate = nextEventDate;
                state.selectedDate = nextEventDate;
                renderAll();
            });
        }
    }

    // ===================================================================
    // 6. INITIALIZATION
    // ===================================================================
    async function start() {
        state.allEvents = await fetchAllEvents();
        renderAll();
        // Periodically re-render to update the live status
        setInterval(renderAll, 60000); // Re-render every minute
        addEventListeners();
    }

    start();
  }

  const allCalendarSections = document.querySelectorAll('.rk-section-container');
  allCalendarSections.forEach(initializeCalendar);
});

  } catch(e) { console.error(e); }
})();
})();
